import { startOfDay, formatISO } from 'date-fns';

const getStartOfTheDayISO = (date?: string): string | undefined =>
	date ? formatISO(startOfDay(new Date(date))) : undefined;

export default getStartOfTheDayISO;
